module.exports = __webpack_public_path__ + "img/pinpaizhiyou.cf113ce0.png";